'use strict';

angular.module('configModule', [
    'ngKomondorResourceView'
]);